module.exports = __webpack_public_path__ + "img/violin.68f61149.svg";